module.exports = __webpack_public_path__ + "icons/cancel.b0f97d64.svg";